import React, { useEffect, useState } from "react";
import ipeEnquiryService from "../../services/ipeEnquiryService";

export default function SkillSelectorModal({
  show,
  onClose,
  onSelect,
  selected = [],
  primary = null
}) {
  const [skills, setSkills] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [primaryId, setPrimaryId] = useState(null);

  useEffect(() => {
    if (show) {
      load();
      setSelectedIds(selected.map(s => s.id));
      setPrimaryId(primary);
    }
  }, [show]);

  async function load() {
    try {
      const data = await ipeEnquiryService.getSkills();
      setSkills(data);
    } catch (e) {
      console.error("Skill load failed", e);
    }
  }

  function toggle(id) {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter(x => x !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  }

  function submit() {
    const selectedSkills = skills.filter(s =>
      selectedIds.includes(s.id)
    );

    onSelect({
      skills: selectedSkills,
      primary: primaryId
    });

    onClose();
  }

  if (!show) return null;

  return (
    <div className="modal d-block" style={{ background: "#00000055" }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">

          <div className="modal-header">
            <h5>Select Skills</h5>
          </div>

          <div className="modal-body">

            {skills.map(s => (
              <div key={s.id} className="d-flex justify-content-between border p-2 mb-1">

                <div>
                  <input
                    type="checkbox"
                    checked={selectedIds.includes(s.id)}
                    onChange={() => toggle(s.id)}
                  />
                  <span className="ms-2">{s.skill_name}</span>
                </div>

                <div>
                  <input
                    type="radio"
                    name="primarySkill"
                    checked={primaryId === s.id}
                    onChange={() => setPrimaryId(s.id)}
                  />
                  <span className="ms-1">Primary</span>
                </div>

              </div>
            ))}

          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary btn-sm" onClick={onClose}>
              Cancel
            </button>

            <button className="btn btn-primary btn-sm" onClick={submit}>
              Add Selected
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}